import { render, staticRenderFns } from "./_generalLedger.vue?vue&type=template&id=8eacadc2&scoped=true&"
import script from "./_generalLedger.vue?vue&type=script&lang=js&"
export * from "./_generalLedger.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8eacadc2",
  null
  
)

export default component.exports